export default `
<g id="button">
  <circle
    cx="0" cy="0" r="3.4"
    style="stroke:var(--pattern-mark);fill:none;stroke-width:var(--pattern-stroke);"
  />
  <circle cx="-1" cy="-1" r="0.5" style="stroke:none;fill:var(--pattern-mark)"/>
  <circle cx="1"  cy="-1" r="0.5" style="stroke:none;fill:var(--pattern-mark)" />
  <circle cx="1"  cy="1"  r="0.5" style="stroke:none;fill:var(--pattern-mark)" />
  <circle cx="-1" cy="1"  r="0.5" style="stroke:none;fill:var(--pattern-mark)" />
</g>`

